import { Avatar, Typography } from '@mui/material';
import { FC } from 'react';
import { useAppSelector } from '../../store/hooks';
import styles from './ProfileMenuItem.module.css';

interface ProfileMenuItemProps {
}

const ProfileMenuItem: FC<ProfileMenuItemProps> = (props) => {
  const { user, selectedAccount } = useAppSelector(state => state.auth);
 
  return (<div className={styles.ProfileMenuItem}>
    <div className='flex v-center'>
      <div>
      <Avatar
        alt={user?.name || 'Picture'}
        imgProps={{ "referrerPolicy": 'no-referrer'}}
        src={`${user?.profilePic}`}
        style={{ width: '32px', height: '32px', objectFit: 'contain' }}
      />
      </div>
      
      <div className="flex-column">
        <div>
          <Typography variant="subtitle1">{user?.name}</Typography>
        </div>
       <div
       style={{display:"flex"}}>
          <div style={{flex:"1", marginRight:"20px"}}>
            <Typography sx={{ width: '70px', whiteSpace: 'nowrap', overflow: 'hidden', fontSize:'14px',
            textOverflow: 'ellipsis'}} variant="subtitle2" >{selectedAccount?.name}</Typography>
          </div>
          <div style={{flex:"1"}}>
            <Typography variant="subtitle2" sx={{pt:'3px'}}>{selectedAccount?.subscription?.plan}</Typography>
          </div>
       </div>
        <div style={{display:"flex", marginTop:"3px"}}>
          <div  style={{flex:"1",marginRight:'35px'}}>
          <Typography variant="subtitle2">{user?.roles && user?.roles[0]?.role}</Typography>
          </div>
          
        </div>
      </div>
    </div>

  </div>
  );
};

export default ProfileMenuItem;
